import axios from "axios";
import React from "react";
import { MdOutlineDarkMode, MdDarkMode } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { MyGlobalContext } from "../../Context";


const SubProfile = ({ setRunDarkMode, isDarkMode }) => {
  const navigate = useNavigate();
  const { token, setRunToken } = MyGlobalContext();
  const onDarkMode = () => {
    localStorage.setItem("DarkMode", "Dark");
    setRunDarkMode(1);
  };
  const OffDarkMode = () => {
    localStorage.setItem("DarkMode", "Light");
    setRunDarkMode(2);
  };
  const OnClickLogout = () => {
    axios
      .get("https://cocktailshop.onrender.com/logout", {
        headers: { Authorization: token },
        withCredentials: true,
      })
      .then((res) => {
        if (res.status === 201) {
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 1000,
          });
          localStorage.removeItem("CocktailToken");
          setRunToken(10);
          navigate("/");
        }
      })
      .catch((err) => {
        toast.warn(err.response.data.message, {
          position: "top-center",
          autoClose: 1000,
        });
      });
  };
  return (
    <article className=" max-w-[700px] bg-[rgba(4,4,116,0.5)] pb-14 mx-auto rounded-sm shadow-lg shadow-[#114ae9] relative prof-article">
      <p
        className={`flex justify-center items-center absolute left-[50%] top-[-25px] translate-x-[-50%] h-16 w-16 rounded-[50%] bg-[rgba(0,0,0,0.8)] uppercase font-extrabold shadow-inner shadow-[blue] ${
          isDarkMode === "Light" && "bg-[rgba(200,199,199,0.8)]"
        }`}
      >
        Sh
      </p>
      <div className="flex justify-center md:justify-evenly flex-wrap pt-20 pb-5 px-5 text-whtie">
        <p className="text-center p-2">Md Niamul Hakim Shawn</p>
        <p className=" p-2">13238673203</p>
      </div>
      <div className=" flex justify-center flex-wrap">
        <span className=" m-1 py-1 px-5 rounded-md flex items-center">
          Dark Mode:
          <button className="ml-2 border-[2px]  flex  items-center rounded-md transition-all">
            <span
              onClick={onDarkMode}
              className={` py-[6px] px-1 ${
                isDarkMode === "Dark" && "darkModeColor"
              }`}
            >
              <MdOutlineDarkMode />
            </span>
            <span
              onClick={OffDarkMode}
              className={`py-[6px] px-1 ${
                isDarkMode === "Light" && "offDarkMode"
              }`}
            >
              <MdDarkMode />
            </span>
          </button>
        </span>
        <button onClick={OnClickLogout} className="border-2  m-1 py-1 px-5 rounded-md">Logout</button>
      </div>
    </article>
  );
};

export default SubProfile;
